import feathersClient, { makeServicePlugin, BaseModel } from '../../feathers-client'

class CompassGoals extends BaseModel {
  // Required for $FeathersVuex plugin to work after production transpile.

  static modelName = 'CompassGoals'
  // Define default properties here
  static instanceDefaults () {
    return {
      compassId: '',
      isAccepted: false,
      description: '',
    }
  }
}
const servicePath = 'compass-goals'
const servicePlugin = makeServicePlugin({
  Model: CompassGoals,
  service: feathersClient.service(servicePath),
  servicePath,
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [
      () => {
        console.log('created goal!')
      },
    ],
    update: [],
    patch: [],
    remove: [],
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: [],
  },
})

export default servicePlugin
